import { useAppSelector } from '../../../hooks';
import { Progress } from 'reactstrap';
import { parseDate } from '../../../Utility/parseDate';
import { Link } from 'react-router-dom';
import Loading from '../../../Components/Loading';
import { Card } from 'reactstrap';
import './SellAThon.css';

const SellAThonCard = () => {
    const data = useAppSelector((state) => state.sellAThon.salesArr);
    const loading = useAppSelector((state) => state.sellAThon.loading);
    const error = useAppSelector((state) => state.sellAThon.error);

    const weeks = data?.weeks;

    if (error) {
        return (
            <Card>
                <span className='headerText'>Weekly Sell-A-Thon</span>
                {error && <span style={{ color: 'red'}}>Error: {error}</span>}
            </Card>
        )
    };

    if (!Array.isArray(weeks) || weeks.length === 0) {
        return (
            <Card>
                <span className='headerText'>Weekly Sell-A-Thon</span>
                <span className='itemDescription'>No Current Sell-A-Thon Data</span>
            </Card>
        )
    };

    const week = weeks[0];

    const target = parseInt(data?.weeks?.[0].weekTarget)
    const sales = parseInt(data?.weeks?.[0].weekSales)

    if (!target || !sales || target <= 0) {
        return (
            <Card>
                <span className='headerText'>Weekly Sell-A-Thon</span>
                <span className='itemDescription'>No Current Sell-A-Thon Data</span>
            </Card>
        );
    };

    const progress = parseFloat((sales / target).toFixed(2));
    const endDate = parseDate(data?.weeks?.[0].weekEndDate)
    const msInDays = 1000 * 60 * 60 * 24
    const daysLeft = Math.max(
        Math.ceil((Number(endDate) - Date.now()) / msInDays),
        0
    );


    return (
        <Link to='/SellAThon' style={{ textDecoration: 'none' }}>
            <Card className='shadow border-0 bg-light'>
                <span className='headerText'>Weekly Sell-A-Thon</span>
                {loading
                    ? (<Loading />)
                    : (
                        <Progress
                            value={progress * 100}
                            color='primary'
                        />
                    )
                }
                <span className='itemDescription'>{Math.round(progress * 100)}% of this week's Goal!</span>
            </Card>
        </Link>
    );
};

export default SellAThonCard;